export default __webpack_public_path__ + "static/media/Privitrides_banner.aa3da53c.png";